<template>
  <div class="d-none d-xl-block">
    <b-button
      v-if="showArrowButton"
      v-b-tooltip.hover
      :disabled="disableScrollTopButton"
      variant="none"
      :class="['arrow-button']"
      :style="arrowButtonStyle"
      :title="lang != 'ENG' ? '위로 가기' : 'Go to top'"
      @click="scrollToTop"
    >
      <div class="icon-container" :style="iconContainerStyle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          fill="#FFFFFF"
          class="bi bi-arrow-up-circle-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"
          />
        </svg>
      </div>
    </b-button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ArrowButton',
  props: {
    disableScrollTopButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showArrowButton: false
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['lang']),
    ...mapGetters(['is_viewer']),
    arrowButtonStyle() {
      return {
        position: 'fixed',
        bottom: this.is_viewer ? '13.5px' : '80px',
        right: '7.2px',
        zIndex: '1070',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: this.is_viewer ? this.selected_report.main_color : '#33a2a9',
        padding: '0 10px'
      };
    },
    iconContainerStyle() {
      const baseStyle = {
        background: 'linear-gradient(45deg, #008895, #007695)',
        borderRadius: '24px',
        padding: '11.3px',
        boxShadow: 'rgba(149, 157, 165, 0.5) 0px 0px',
        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
        border: '1.4px solid  #33a2a9'
      };
      if (this.is_viewer) {
        baseStyle.background = this.selected_report.main_color;
        baseStyle.border = `1.4px solid ${this.selected_report.main_color}`;
      }
      return baseStyle;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showArrowButton = window.scrollY > 100;
    }
  }
};
</script>

<style scoped>
.arrow-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.arrow-button:hover:not(:disabled) {
  color: black;
}

.icon-container:hover {
  box-shadow: rgba(149, 157, 165, 0.55) 0px 8px 16px;
}

.icon-container svg {
  width: 32px;
  height: 32px;
  fill: white;
}
</style>
